import { render, staticRenderFns } from "./managementDetailsHistory.vue?vue&type=template&id=aa8c75f0"
import script from "./managementDetailsHistory.vue?vue&type=script&lang=js"
export * from "./managementDetailsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports